import { DigioUploadPayload } from "../types/digio/K2Digio";

interface BuildDigioPayloadParams {
  remitterUserKey: string;
  loggedInUserKey: string;
  selectedRemitter: any;
  selectedRecipient: any;
  amountCalculation: any;
  transactionSummary: any;
  sendType: "email" | "sms";
  sourceOfFunds?: string;
}

export const buildDigioPayload = ({
  remitterUserKey,
  loggedInUserKey,
  selectedRemitter,
  selectedRecipient,
  amountCalculation,
  transactionSummary,
  sendType,
  sourceOfFunds,
}: BuildDigioPayloadParams): DigioUploadPayload => {
  const totalYouPay = amountCalculation?.roundOff
    ? transactionSummary?.totalPayInCeils?.find((item: any) => item.id === 10)?.total_pay
    : transactionSummary?.total_pay;

  const signerName = [selectedRemitter?.firstName, selectedRemitter?.lastName]
    .filter(Boolean)
    .join(" ")
    .trim();

  const payload: DigioUploadPayload = {
    userKey: remitterUserKey,
    loggedInUserKey,
    requestType: "k2",
    purpose_code: amountCalculation?.purposeCode ?? "",
    purpose_description: amountCalculation?.transaction_purpose ?? "",
    signerName,
    sendType,
    pan_num: amountCalculation?.pan_number ?? "",
    city: selectedRemitter?.city ?? "",
    dest_curr: amountCalculation?.dest_currency ?? "",
    pincode: selectedRemitter?.pinCode ?? "",
    recipientId: selectedRecipient?.id ?? "",
    reciepient_recieve: Number(transactionSummary?.reciepient_recieve ?? 0),
    recipeint_accnt_num: selectedRecipient?.bankAccountNumber ?? "",
    recipient_bank_name: selectedRecipient?.bankName ?? "",
    recipient_first_name: selectedRecipient?.firstName ?? "",
    recipient_last_name: selectedRecipient?.lastName ?? "",
    reicpient_bank_accnt_country: selectedRecipient?.bankAccountCountry ?? "",
    state: selectedRecipient?.bankAccountCountry ?? "",
    total_pay: Number(totalYouPay ?? 0),
    user_address1: selectedRemitter?.addressLine1 ?? "",
    user_first_name: selectedRemitter?.firstName ?? "",
    user_last_name: selectedRemitter?.lastName ?? "",
    bene: Boolean(amountCalculation?.isBene),
    sourceOfFunds: sourceOfFunds ?? "",
  };

  if (sendType === "email") {
    payload.email = selectedRemitter?.email ?? "";
  } else {
    payload.phone = selectedRemitter?.phoneNumber ?? "";
  }

  return payload;
};
